import { RequestOptions } from './request-options';

export class PlanStageCompaund extends RequestOptions {
    Id_Stage: number;
    Id_OrigProduct: number;
    Id_RealProduct: number;
    OrigProductName: string;
    RealProductName: string;
    Id_PlanStageCompaund: number;
    CalculationWeightReal: number;
    CalculationWeightOrig: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/menu-plan-stage-compaund.ts